import React from 'react';

import { HomePage } from '../../../features/HomePage/HomePage';

export const Home: React.VFC = () => {
    return <HomePage service='Ratings' />;
};
